import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['checkbox', 'submit']

  connect () {
    this.sync()
  }

  sync () {
    if (!this.hasSubmitTarget) return

    const allChecked = this.checkboxTargets.every(
      (checkbox) => checkbox.checked
    )
    this.submitTarget.disabled = !allChecked
    this.submitTarget.setAttribute('aria-disabled', String(!allChecked))
  }
}
